import React from 'react';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';

import styles from './styles.module.less';

const ProvisionalFilterModal = ({
  title,
  hideModalFn,
  imageSrc,
  description,
  btnText,
  backgroundSize,
}) => (
  <div className={styles.modalContainer}>
    <h3 className={styles.modalTitle}>{title}</h3>
    <div
      style={{
        backgroundImage: `url(${imageSrc})`,
        backgroundSize: backgroundSize || 'cover',
      }}
      className={styles.modalPicture}
    />
    <div className={styles.modalDescription}>{description}</div>
    <div className={styles.modalAction}>
      <ButtonV2 onClick={hideModalFn} className={styles.modalActionButton}>
        {btnText}
      </ButtonV2>
    </div>
  </div>
);

export default ProvisionalFilterModal;
